import List from '@/shared/dtos/List'
import { HttpService } from '@/shared/services'
import ExternalLetterMapped from '../models/ExternalLetterMapped'
import ICreateExternalLetterInputDto from './dtos/ICreateExternalLetters'
import IUpdateExternalLetter from './dtos/IUpdateExternalLetter'

const http = new HttpService()

export const uploadExternalLettersZip = async (
  file: File,
  companyId: string
) => {
  const formData = new FormData()

  formData.append('file', file)

  const response = await http.post<any, List<ExternalLetterMapped[]>>(
    '/externalLetters/validate' + '?companyId=' + companyId,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return response.data
}

export const createExternalLetters = async (
  data: ICreateExternalLetterInputDto
) => {
  const response = await http.post<ICreateExternalLetterInputDto, string>(
    '/externalLetters/create',
    data
  )
  return response.data
}

export const updateExternalLetters = async (data: IUpdateExternalLetter) => {
  const response = await http.put<IUpdateExternalLetter, string>(
    '/externalLetters/' + data.letterConfigId,
    data
  )
  return response.data
}
